export const feeHandlerABI = [
    {
        payable: false,
        stateMutability: 'nonpayable',
        type: 'constructor',
        inputs: [{ name: 'test', internalType: 'bool', type: 'bool' }],
    },
    {
        type: 'event',
        anonymous: false,
        inputs: [{ name: 'beneficiary', internalType: 'address', type: 'address', indexed: false }],
        name: 'BeneficiaryAdded',
    },
    {
        type: 'event',
        anonymous: false,
        inputs: [
            { name: 'beneficiary', internalType: 'address', type: 'address', indexed: false },
            { name: 'fraction', internalType: 'uint256', type: 'uint256', indexed: false },
        ],
        name: 'BeneficiaryFractionSet',
    },
    {
        type: 'event',
        anonymous: false,
        inputs: [
            { name: 'beneficiary', internalType: 'address', type: 'address', indexed: false },
            { name: 'name', internalType: 'string', type: 'string', indexed: false },
        ],
        name: 'BeneficiaryNameSet',
    },
    {
        type: 'event',
        anonymous: false,
        inputs: [{ name: 'beneficiary', internalType: 'address', type: 'address', indexed: false }],
        name: 'BeneficiaryRemoved',
    },
    {
        type: 'event',
        anonymous: false,
        inputs: [{ name: 'fraction', internalType: 'uint256', type: 'uint256', indexed: false }],
        name: 'BurnFractionSet',
    },
    {
        type: 'event',
        anonymous: false,
        inputs: [{ name: 'fraction', internalType: 'uint256', type: 'uint256', indexed: false }],
        name: 'CarbonFractionSet',
    },
    {
        type: 'event',
        anonymous: false,
        inputs: [
            { name: 'token', internalType: 'address', type: 'address', indexed: false },
            { name: 'burning', internalType: 'uint256', type: 'uint256', indexed: false },
        ],
        name: 'DailyLimitHit',
    },
    {
        type: 'event',
        anonymous: false,
        inputs: [
            { name: 'tokenAddress', internalType: 'address', type: 'address', indexed: false },
            { name: 'newLimit', internalType: 'uint256', type: 'uint256', indexed: false },
        ],
        name: 'DailyLimitSet',
    },
    {
        type: 'event',
        anonymous: false,
        inputs: [{ name: 'amount', internalType: 'uint256', type: 'uint256', indexed: false }],
        name: 'DailySellLimitUpdated',
    },
    {
        type: 'event',
        anonymous: false,
        inputs: [
            { name: 'tokenAddress', internalType: 'address', type: 'address', indexed: false },
            { name: 'amount', internalType: 'uint256', type: 'uint256', indexed: false },
        ],
        name: 'DistributionAmountSet',
    },
    {
        type: 'event',
        anonymous: false,
        inputs: [{ name: 'newBeneficiary', internalType: 'address', type: 'address', indexed: false }],
        name: 'FeeBeneficiarySet',
    },
    {
        type: 'event',
        anonymous: false,
        inputs: [
            { name: 'token', internalType: 'address', type: 'address', indexed: false },
            { name: 'maxSlippage', internalType: 'uint256', type: 'uint256', indexed: false },
        ],
        name: 'MaxSlippageSet',
    },
    {
        type: 'event',
        anonymous: false,
        inputs: [
            { name: 'previousOwner', internalType: 'address', type: 'address', indexed: true },
            { name: 'newOwner', internalType: 'address', type: 'address', indexed: true },
        ],
        name: 'OwnershipTransferred',
    },
    {
        type: 'event',
        anonymous: false,
        inputs: [{ name: 'registryAddress', internalType: 'address', type: 'address', indexed: true }],
        name: 'RegistrySet',
    },
    {
        type: 'event',
        anonymous: false,
        inputs: [
            { name: 'token', internalType: 'address', type: 'address', indexed: false },
            { name: 'value', internalType: 'uint256', type: 'uint256', indexed: false },
        ],
        name: 'SoldAndBurnedToken',
    },
    {
        type: 'event',
        anonymous: false,
        inputs: [
            { name: 'tokenAddress', internalType: 'address', type: 'address', indexed: false },
            { name: 'handlerAddress', internalType: 'address', type: 'address', indexed: false },
        ],
        name: 'TokenAdded',
    },
    {
        type: 'event',
        anonymous: false,
        inputs: [{ name: 'tokenAddress', internalType: 'address', type: 'address', indexed: false }],
        name: 'TokenRemoved',
    },
    { payable: true, stateMutability: 'payable', type: 'fallback' },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [],
        name: 'FIXED1_UINT',
        outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [],
        name: 'MIN_BURN',
        outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [],
        name: 'ignoreRenaming_carbonFeeBeneficiary',
        outputs: [{ name: '', internalType: 'address', type: 'address' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [],
        name: 'initialized',
        outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [],
        name: 'isOwner',
        outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [],
        name: 'owner',
        outputs: [{ name: '', internalType: 'address', type: 'address' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [],
        name: 'registry',
        outputs: [{ name: '', internalType: 'contract IRegistry', type: 'address' }],
    },
    {
        constant: false,
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [],
        name: 'renounceOwnership',
        outputs: [],
    },
    {
        constant: false,
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [{ name: 'registryAddress', internalType: 'address', type: 'address' }],
        name: 'setRegistry',
        outputs: [],
    },
    {
        constant: false,
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [{ name: 'newOwner', internalType: 'address', type: 'address' }],
        name: 'transferOwnership',
        outputs: [],
    },
    {
        constant: false,
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [
            { name: '_registryAddress', internalType: 'address', type: 'address' },
            { name: 'newFeeBeneficiary', internalType: 'address', type: 'address' },
            { name: 'newCarbonFraction', internalType: 'uint256', type: 'uint256' },
            { name: 'tokens', internalType: 'address[]', type: 'address[]' },
            { name: 'handlers', internalType: 'address[]', type: 'address[]' },
            { name: 'newLimits', internalType: 'uint256[]', type: 'uint256[]' },
            { name: 'newMaxSlippages', internalType: 'uint256[]', type: 'uint256[]' },
        ],
        name: 'initialize',
        outputs: [],
    },
    {
        constant: false,
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [{ name: 'newFraction', internalType: 'uint256', type: 'uint256' }],
        name: 'setCarbonFraction',
        outputs: [],
    },
    {
        constant: false,
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [{ name: 'tokenAddress', internalType: 'address', type: 'address' }],
        name: 'setDistributionAndBurnAmounts',
        outputs: [],
    },
    {
        constant: false,
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [
            { name: 'beneficiary', internalType: 'address', type: 'address' },
            { name: '_newFraction', internalType: 'uint256', type: 'uint256' },
        ],
        name: 'changeOtherBeneficiaryAllocation',
        outputs: [],
    },
    {
        constant: false,
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [
            { name: 'beneficiary', internalType: 'address', type: 'address' },
            { name: '_newFraction', internalType: 'uint256', type: 'uint256' },
            { name: 'name', internalType: 'string', type: 'string' },
        ],
        name: 'addOtherBeneficiary',
        outputs: [],
    },
    {
        constant: false,
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [{ name: 'beneficiary', internalType: 'address', type: 'address' }],
        name: 'removeOtherBeneficiary',
        outputs: [],
    },
    {
        constant: false,
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [
            { name: 'beneficiaryAddress', internalType: 'address', type: 'address' },
            { name: '_newFraction', internalType: 'uint256', type: 'uint256' },
        ],
        name: 'setBeneficiaryFraction',
        outputs: [],
    },
    {
        constant: false,
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [
            { name: 'beneficiary', internalType: 'address', type: 'address' },
            { name: 'name', internalType: 'string', type: 'string' },
        ],
        name: 'setBeneficiaryName',
        outputs: [],
    },
    {
        constant: false,
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [{ name: 'beneficiary', internalType: 'address', type: 'address' }],
        name: 'setCarbonFeeBeneficiary',
        outputs: [],
    },
    {
        constant: false,
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [{ name: 'tokenAddress', internalType: 'address', type: 'address' }],
        name: 'sell',
        outputs: [],
    },
    {
        constant: false,
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [
            { name: 'tokenAddress', internalType: 'address', type: 'address' },
            { name: 'handlerAddress', internalType: 'address', type: 'address' },
        ],
        name: 'addToken',
        outputs: [],
    },
    {
        constant: false,
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [{ name: 'tokenAddress', internalType: 'address', type: 'address' }],
        name: 'activateToken',
        outputs: [],
    },
    {
        constant: false,
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [{ name: 'tokenAddress', internalType: 'address', type: 'address' }],
        name: 'deactivateToken',
        outputs: [],
    },
    {
        constant: false,
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [
            { name: 'tokenAddress', internalType: 'address', type: 'address' },
            { name: 'handlerAddress', internalType: 'address', type: 'address' },
        ],
        name: 'setHandler',
        outputs: [],
    },
    {
        constant: false,
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [{ name: 'tokenAddress', internalType: 'address', type: 'address' }],
        name: 'removeToken',
        outputs: [],
    },
    {
        constant: false,
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [{ name: 'tokenAddress', internalType: 'address', type: 'address' }],
        name: 'distribute',
        outputs: [],
    },
    {
        constant: false,
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [
            { name: 'token', internalType: 'address', type: 'address' },
            { name: 'newMax', internalType: 'uint256', type: 'uint256' },
        ],
        name: 'setMaxSplippage',
        outputs: [],
    },
    {
        constant: false,
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [
            { name: 'token', internalType: 'address', type: 'address' },
            { name: 'newLimit', internalType: 'uint256', type: 'uint256' },
        ],
        name: 'setDailySellLimit',
        outputs: [],
    },
    {
        constant: false,
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [],
        name: 'burnCelo',
        outputs: [],
    },
    {
        constant: false,
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [],
        name: 'distributeAll',
        outputs: [],
    },
    {
        constant: false,
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [],
        name: 'handleAll',
        outputs: [],
    },
    {
        constant: false,
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [{ name: 'tokenAddress', internalType: 'address', type: 'address' }],
        name: 'handle',
        outputs: [],
    },
    {
        constant: false,
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [
            { name: 'token', internalType: 'address', type: 'address' },
            { name: 'recipient', internalType: 'address', type: 'address' },
            { name: 'value', internalType: 'uint256', type: 'uint256' },
        ],
        name: 'transfer',
        outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [],
        name: 'getCeloToBeBurned',
        outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [{ name: 'token', internalType: 'address', type: 'address' }],
        name: 'getPastBurnForToken',
        outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [],
        name: 'carbonFeeBeneficiary',
        outputs: [{ name: '', internalType: 'address', type: 'address' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [{ name: 'tokenAddress', internalType: 'address', type: 'address' }],
        name: 'getTokenHandler',
        outputs: [{ name: '', internalType: 'address', type: 'address' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [{ name: 'tokenAddress', internalType: 'address', type: 'address' }],
        name: 'getTokenActive',
        outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [{ name: 'tokenAddress', internalType: 'address', type: 'address' }],
        name: 'getTokenMaxSlippage',
        outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [{ name: 'tokenAddress', internalType: 'address', type: 'address' }],
        name: 'getTokenDailySellLimit',
        outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [{ name: 'tokenAddress', internalType: 'address', type: 'address' }],
        name: 'getTokenCurrentDaySellLimit',
        outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [{ name: 'tokenAddress', internalType: 'address', type: 'address' }],
        name: 'getTokenToDistribute',
        outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [{ name: 'tokenAddress', internalType: 'address', type: 'address' }],
        name: 'getTokenToBurn',
        outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [],
        name: 'getCarbonFraction',
        outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [],
        name: 'getBurnFraction',
        outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [{ name: 'beneficiary', internalType: 'address', type: 'address' }],
        name: 'getOtherBeneficiariesInfo',
        outputs: [
            { name: '', internalType: 'uint256', type: 'uint256' },
            { name: '', internalType: 'string', type: 'string' },
            { name: '', internalType: 'bool', type: 'bool' },
        ],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [],
        name: 'getTotalFractionOfOtherBeneficiariesAndCarbon',
        outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [],
        name: 'getOtherBeneficiariesAddresses',
        outputs: [{ name: '', internalType: 'address[]', type: 'address[]' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'pure',
        type: 'function',
        inputs: [],
        name: 'getVersionNumber',
        outputs: [
            { name: '', internalType: 'uint256', type: 'uint256' },
            { name: '', internalType: 'uint256', type: 'uint256' },
            { name: '', internalType: 'uint256', type: 'uint256' },
            { name: '', internalType: 'uint256', type: 'uint256' },
        ],
    },
    {
        constant: false,
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [
            { name: 'token', internalType: 'address', type: 'address' },
            { name: 'amountToBurn', internalType: 'uint256', type: 'uint256' },
        ],
        name: 'dailySellLimitHit',
        outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [],
        name: 'getActiveTokens',
        outputs: [{ name: '', internalType: 'address[]', type: 'address[]' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [],
        name: 'shouldBurn',
        outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    },
];
